import { modal } from '@codeleap/modals'
import { View, Text, Icon, Touchable } from '@/components'
import { createStyles } from '@codeleap/styles'
import { textVariant, theme } from '@/config'

type ProfileAvatarPickerParams = {
  onUpload?: () => void
  onRemove?: () => void
  hasAvatar?: boolean
}

export const ProfileAvatarPickerModal = modal<ProfileAvatarPickerParams>({ id: 'profile-avatar-picker-modal' })
  .content(({ onUpload, onRemove, hasAvatar, toggle }) => {
    const handleUpload = () => {
      toggle()
      onUpload?.()
    }

    const handleRemove = () => {
      toggle()
      onRemove?.()
    }

    return (
      <View style={['column']}>
        <Text text='Edit profile photo' style={styles.title} />
        <Item icon='image-01' text='Upload photo' onPress={handleUpload} />
        {hasAvatar && (
          <Item icon='trash-03' text='Remove photo' onPress={handleRemove} variant='error' />
        )}
      </View>
    )
  })
  .props({
    showClose: false,
    style: ['centered', 'box:responsiveness', 'box:noPadding'],
  })

function Item({ text, icon, onPress, variant = 'neutral' }) {
  const isError = variant === 'error'

  return (
    <Touchable debugName={`ProfileAvatarPickerModal:${text}`} onPress={onPress}>
      <View style={styles.itemWrapper}>
        <Icon style={[styles.icon, isError && styles.iconError]} name={icon} />
        <Text style={[styles.text, isError && styles.textError]} text={text} />
      </View>
    </Touchable>
  )
}

const styles = createStyles(appTheme => ({
  title: {
    ...appTheme.presets.textCenter,
    ...appTheme.spacing.padding(2),
    ...textVariant(['p3', 'medium']),
    color: appTheme.colors.textHeadingHighlighted,
  },
  itemWrapper: {
    ...appTheme.presets.fullWidth,
    ...appTheme.spacing.paddingHorizontal(3),
    ...appTheme.spacing.paddingVertical(2),
    ...appTheme.presets.row,
    ...appTheme.presets.alignCenter,
    ...appTheme.presets.justifyStart,
    ...appTheme.border({ color: 'neutralSolid300', width: 1, directions: ['bottom'] }),
  },
  icon: {
    marginRight: appTheme.spacing.value(1),
    color: appTheme.baseColors.neutralSolid600,
    ...appTheme.sized(3),
  },
  iconError: {
    color: appTheme.baseColors.redSolid500,
  },
  text: {
    ...textVariant('p3'),
    color: theme.colors.textHeadingHighlighted,
  },
  textError: {
    color: appTheme.baseColors.redSolid500,
  },
}))
